<template>
  <div class="box-form box-form-products">
    <v-form>
      <v-card-text class="modal-cadastro-form">
        <v-row class="align-center">
          <v-col cols="5" md="12" class="modal-cadastro-form-col-imput">
            <label> Selecione um Afiliado: </label>
            <autoCompleteEntities :inativos="false" :entityProps.sync="this.affiliateId" :label="'Afiliados'" :disabled="disabledEdit" :errorMessages="errorMessages"/>
          </v-col>
          <v-col cols="4" class="modal-cadastro-form-col-imput">
          </v-col>
        </v-row>
      </v-card-text>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { mask } from 'vue-the-mask'
import variables from '@/assets/styles/helpers/_variables.scss'
// import { errorSnackbar } from '@/core/service/utils'

export default {
  name: 'BrModalCadastroAts',
  mixins: [validationMixin],
  directives: { mask },
  components: {
    autoCompleteEntities: () => import('./autoCompleteEntities')
  },
  props: {
    affiliateId: {
      type: String || Number,
      default: (() => { })
    },
    disabledEdit: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: () => []
    },
  },
  data: () => ({
    activeModal: false,
    loading: false,
    search: '',
    loadingTable: false,
    loadingContrato: false,
    affiliateRef: ''
  }),
  watch: {
    // 'affiliateRef'(val) {
    //   this.setParentIdAffiliate(val)
    // }
  },
  computed: {
    ...mapGetters('roles', ['permiteAcao']),
    ...mapGetters('afiliadosPendentes', ['listaAllAffiliates', 'getParentIdAffiliate', 'parentIdAffiliate']),
    variables: () => variables,
  },
  mounted() {
    this.getData()
    // this.affiliateRef = this.affiliateId
  },
  methods: {
    ...mapActions('afiliadosPendentes', ['obterTodosAfiliados', 'setParentIdAffiliate']),

    getData() {
      this.loadingTable = true
      this.afiliado = { id: 0 }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/styles/components/formularios';
@import '../../../../assets/styles/components/modal-cadastro';

.br-btn-entity-products {
  margin-top: 10px;
  min-width: auto !important;
  font-size: 0.8em !important;
}

.modal-cadastro-titulo {
  background: #6d7278;
  color: #FFF !important;
}
</style>